import ApiClient from '@/libs/http-client'

const CompanyService = {
    listProjects(params = {}, config = {}) {
        return ApiClient.get('/api/company/projects', { ...config, params })
    },
    getProject(id, config = {}) {
        return ApiClient.get(`/api/company/projects/${id}`, config)
    },
    createProject(payload, config = {}) {
        return ApiClient.post('/api/company/projects', payload, config)
    },
    updateProject(id, payload, config = {}) {
        return ApiClient.put(`/api/company/projects/${id}`, payload, config)
    },
    deleteProject(id, config = {}) {
        return ApiClient.delete(`/api/company/projects/${id}`, config)
    },
}

export default CompanyService
